import { User } from "lucide-react";

export const UserAvatar = ({ profile, size = 32, className = "" }) => {
  const style = { width: size, height: size };

  if (!profile) {
    return (
      <div className={`bg-[#12121a] border border-white/10 rounded-full flex items-center justify-center ${className}`} style={style} data-testid="navbar-avatar">
        <User className="w-4 h-4" />
      </div>
    );
  }

  if (profile.avatar_type === "photo" && profile.avatar_photo) {
    return (
      <div className={`rounded-full border border-white/10 ${className}`} style={{ ...style, background: `url(${profile.avatar_photo}) center/cover` }} data-testid="navbar-avatar" />
    );
  }

  const colors = profile.avatar_gradient?.length ? profile.avatar_gradient : [profile.avatar_color || "#3B82F6"];
  let background;
  if (colors.length >= 2) {
    background = `linear-gradient(${profile.avatar_gradient_angle ?? 135}deg, ${colors.join(", ")})`;
  } else {
    const c = colors[0];
    if (profile.avatar_style === "matte") background = `linear-gradient(135deg, ${c}, ${c}88)`;
    else if (profile.avatar_style === "metallic") background = `linear-gradient(135deg, ${c}cc, white, ${c})`;
    else background = c;
  }

  return (
    <div className={`rounded-full border border-white/10 flex items-center justify-center font-bold text-white/90 ${className}`} style={{ ...style, background, fontSize: size * 0.42 }} data-testid="navbar-avatar">
      {(profile.username || "?")[0].toUpperCase()}
    </div>
  );
};

export default UserAvatar;
